<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <h1>All Users</h1>
      </v-col>
      <v-col cols="12">
        <v-data-table class="elevation-1"
                      disable-filtering
                      :disable-pagination="items.length < 10"
                      :hide-default-footer="items.length < 10"
                      :loading="isLoading"
                      :headers="headers"
                      :items="items">
          <template v-slot:item.IsConfirmed="{ item }">
            <span :class="{
                'error--text': !item.IsConfirmed,
                'success--text': item.IsConfirmed
              }">{{ item.IsConfirmed ? 'Confirmed' : 'Not Confirmed' }}</span>
          </template>
          <template v-slot:item.Roles="{ item }">
            {{ friendlyRole(item.RoleValues) }}
          </template>
          <template v-slot:item.Actions="{ item }">
            <v-tooltip top :activator="`#editBtn-${item.Id}`">
              {{ isMine(item.Id) || $store.getters.can('Admin') ? 'Edit' : 'View' }}
            </v-tooltip>
            <v-tooltip top :activator="`#deleteBtn-${item.Id}`">
              Delete
            </v-tooltip>
            <v-btn icon link
                   color="accent"
                   :id="`editBtn-${item.Id}`"
                   :to="profileLink(item.Id)">
              <v-icon>
                {{ isMine(item.Id) || $store.getters.can('Admin') ? 'edit' : 'visibility' }}
              </v-icon>
            </v-btn>
            <v-btn icon link
                   color="accent"
                   v-if="$store.getters.can('Admin')"
                   :disabled="isMine(item.Id)"
                   :id="`deleteBtn-${item.Id}`"
                   @click="$refs.confirm.open(item)">
              <v-icon>delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
      <v-col cols="12" class="text-right" v-if="$store.getters.can('Admin')">
        <v-btn color="primary" dark link :to="{ name: 'user.create' }">
          <v-icon dark left>add</v-icon>
          Create
        </v-btn>
      </v-col>
    </v-row>
    <v-row justify="center" align="center">
      <ConfirmDialog ref="confirm"
                     title="WARNING"
                     width="450"
                     @continue="deleteItem($event)">
        This action will permanently delete this user
        and prevent them from logging into the application.<br>
        <strong>Are you sure you would like to proceed?</strong>
      </ConfirmDialog>
    </v-row>
  </v-container>
</template>

<script>
import { friendlyRole } from '@/components/Mixins/FriendlyFields';

export default {
  name: 'UserIndex',
  data() {
    return {
      loading: true,
      headers: [
        { text: 'First Name', value: 'FirstName' },
        { text: 'Last Name', value: 'LastName' },
        { text: 'Email', value: 'Email' },
        { text: 'Email Status', value: 'IsConfirmed' },
        { text: 'Role', value: 'Roles', sortable: false },
        {
          text: 'Actions',
          value: 'Actions',
          sortable: false,
          filterable: false,
        },
      ],
      items: [],
      isLoading: this.loading,
    };
  },
  methods: {
    friendlyRole,
    isMine(id) {
      return id === this.$store.getters.user.id;
    },
    profileLink(id) {
      return this.isMine(id) ? {
        name: 'user.me',
      } : {
        name: 'user.read',
        params: { id },
      };
    },
    async deleteItem(item) {
      try {
        const i = this.items.indexOf(item);
        await this.$store.dispatch('delete', `User/${item.Id}`);
        this.items.splice(i, 1);
      } catch (e) {
        // Do nothing
      }
    },
  },
  async created() {
    const response = await this.$store.dispatch('get', 'User');
    this.items = response.data;
    this.loading = false;
  },
};
</script>
